import styled from 'styled-components';
import { motion } from 'motion/react';

// Components
import IconButtonClose from '~/components/misc/icon-button-close';
import { Modal } from '~/components/modal/modal';

// Utils
import breakpoint from '~/utils/style-utils';

interface AnimatedWrapperProps {
	iframeLoaded?: boolean;
}

export const ActionButton = styled.button`
	border-radius: var(--base-radius-rounded);
	border: 1px solid var(--main-text-primary);
	width: 100%;
	display: flex;
	padding: 0 24px;
	gap: 8px;
	align-items: center;
	justify-content: center;
	height: 52px;

	* {
		color: var(--main-text-primary);
	}

	h3 {
		padding-bottom: 4px;
	}
`;

export const CloseButton = styled(IconButtonClose)`
	align-items: center;
	background-color: rgba(var(--primary-accent-grey-light), 0.5);
	border-radius: 50%;
	display: flex;
	justify-content: center;
	padding: 4px;

	svg {
		fill: var(--new-qd--modal-header-close-icon-color) !important;
		height: 24px;
		width: 24px;
	}
`;

export const ContentActions = styled.div`
	width: 100%;
`;

export const ContentDetails = styled.div<{ gap?: string }>`
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: flex-start;
	gap: ${({ gap }) => gap || '24px'};

	.confirm-box {
		padding: 0 0 10px;
	}
`;

export const ContentText = styled.small`
	color: var(--base-01);
	font-size: 15px;
	line-height: 20px;
	width: 100%;
`;

export const ContentWrapper = styled.div<{ isDesktop: boolean; center: boolean }>`
	position: absolute;
	align-items: center;
	background-color: rgba(var(--base-04), 1);
	border-radius: 12px 12px 0 0;
	bottom: 0;
	display: flex;
	flex-direction: column;
	gap: 24px;
	min-height: 230px;
	padding: 24px;
	width: ${({ isDesktop }) => (isDesktop ? 'var(--detailWidth)' : '100%')};
	left: ${({ center, isDesktop }) => (isDesktop && center ? '50%' : '0')};
	transform: ${({ center, isDesktop }) => (isDesktop && center ? 'translate(-50%, 0)' : 'none')};

	.continue-button {
		padding-left: 0;
		padding-right: 0;
	}
`;

export const Header = styled.div`
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin: 0;
	text-align: left;
	width: 100%;
`;

export const ModalWrapper = styled(Modal)`
	height: 100%;
	left: auto;
	right: 0;
	top: 0;
`;

export const AnimatedWrapper = styled(motion.div)<AnimatedWrapperProps>`
	position: fixed;
	bottom: 0;
	height: ${props => (props.iframeLoaded ? 'inherit' : '')};
	${breakpoint.sm`
    width: 100%;
  `};
	${breakpoint.lg`
    width: 377px;
  `};
`;
